import { render, staticRenderFns } from "./AllCompanies.vue?vue&type=template&id=3dacca82&"
import script from "./AllCompanies.vue?vue&type=script&lang=js&"
export * from "./AllCompanies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports